import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="category-tree"
export default class extends Controller {
  toggle(event) {
    const checkbox = event.target
    const node = checkbox.closest(".kit-tree-node")
    const childrenEl = node.querySelector(":scope > .kit-tree-node__children")
    if (!childrenEl) return // leaf node — no children

    // Check/uncheck all descendant checkboxes
    childrenEl.querySelectorAll("input[type='checkbox']").forEach(cb => {
      cb.checked = checkbox.checked
    })

    // Auto-expand when checking a parent
    if (checkbox.checked && childrenEl.classList.contains("is-collapsed")) {
      this.setExpanded(node, true)
    }
  }

  toggleExpand(event) {
    const node = event.currentTarget.closest(".kit-tree-node")
    const childrenEl = node.querySelector(":scope > .kit-tree-node__children")
    if (!childrenEl) return

    this.setExpanded(node, childrenEl.classList.contains("is-collapsed"))
  }

  setExpanded(node, expanded) {
    const btn = node.querySelector(":scope > .kit-tree-node__row > .kit-tree-node__toggle")
    const childrenEl = node.querySelector(":scope > .kit-tree-node__children")
    if (btn) btn.setAttribute("aria-expanded", expanded ? "true" : "false")
    if (childrenEl) childrenEl.classList.toggle("is-collapsed", !expanded)
  }
}
